import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer'

export default function About() {
    const [showText, setShowText] = useState(false);

    const handleMouseEnter = () => {
        setShowText(true);
    }

    const handleMouseLeave = () => {
        setShowText(false);
    }

    return (
        <div className="bg-[#e5dedb] min-h-screen relative">
            <div className="absolute inset-0 md:w-1/3 z-0">
                <img src="images/about.jpg" alt="Section Illustration" className="w-full h-full object-cover transition-opacity duration-100" />
            </div>

            <div style={{ backgroundColor: 'rgba(229, 222, 219, 0.7)' }} className=" px-4 md:py-32 py-16 md:w-[72%] md:ml-auto relative overflow-y-auto h-screen z-10 ">

                {/* Introduction */}
                <div className="scroll-section mb-16 grid px-8 gap-8 max-h-[90vh] md:ml-[15%] md:mr-[5%]" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                    <div>
                        <h2 className="text-2xl md:text-3xl font-bold" >About Us</h2>
                        <p className="italic mb-4">
                            关于我们
                        </p>
                        <p className="text-md md:text-xl mb-4 text-justify custom-word-spacing">
                            Welcome to <span className="highlight">Schedio + Partners International</span>. We collaborate and work closely with our clients and business partners, also providing <span className="highlight">business opportunities</span> to those we collaborate with.
                        </p>
                        <p className="text-md md:text-xl mb-4 text-justify custom-word-spacing">
                            We are driven by <span className="highlight">striving towards innovative and creative designs</span>, enhancing the value of our clients’ properties with our unique designs. This is achieved through <span className="highlight">close interaction and a deep understanding</span> of our clients’ needs and expectations.
                        </p>
                        <p className="text-md md:text-xl text-justify custom-word-spacing">
                            Beyond our core business, we are <span className="highlight">passionately committed</span> to making the world a better place through collaboration and design efforts. This mission is guided by the urgent need to <span className="highlight">sustain the environment</span> and preserve the distinct cultures and heritage of cities where our clients’ properties are located.
                        </p>

                    </div>
                </div>

            </div>

            <Header />
        </div>
    );
}
